const activityVisitKeys = new Set()
let memoryGuestVisitorId = ''
const GUEST_VISITOR_ID_KEY = 'member_activity_guest_visitor_id'

const createGuestVisitorId = () => {
    const randomPart = Math.random().toString(36).slice(2, 12)
    return `guest-${Date.now().toString(36)}-${randomPart}`
}

export const getMemberActivityKey = (currentSession, fallback = 'member') => {
    return (
        currentSession?.user?.member_id ||
        currentSession?.member_id ||
        currentSession?.user?.id ||
        fallback
    )
}

export const getGuestVisitorId = () => {
    if (memoryGuestVisitorId) return memoryGuestVisitorId

    try {
        const storedVisitorId = window.localStorage.getItem(GUEST_VISITOR_ID_KEY)
        if (storedVisitorId) {
            memoryGuestVisitorId = storedVisitorId
            return memoryGuestVisitorId
        }

        memoryGuestVisitorId = createGuestVisitorId()
        window.localStorage.setItem(GUEST_VISITOR_ID_KEY, memoryGuestVisitorId)
        return memoryGuestVisitorId
    } catch (error) {
        memoryGuestVisitorId = memoryGuestVisitorId || createGuestVisitorId()
        return memoryGuestVisitorId
    }
}

export const shouldRecordActivityVisit = (key) => {
    if (!key) return false

    const storageKey = `member_activity_visit:${key}`

    if (activityVisitKeys.has(storageKey)) return false

    try {
        if (window.sessionStorage.getItem(storageKey) === '1') return false
        window.sessionStorage.setItem(storageKey, '1')
    } catch (error) {
        // sessionStorage can be unavailable in restricted browser modes.
    }

    activityVisitKeys.add(storageKey)
    return true
}
